export const ComingSoonModal = (props) => {
    return (
        <dialog id="my_coming_soon_modal" className="modal">
            <div className="modal-box">
                <p className="py-4">建设中，即将上线...</p>
            </div>
            <form method="dialog" className="modal-backdrop">
                <button>close</button>
            </form>
        </dialog>
    )
}